import React from 'react';
import { Card } from 'antd';
import JDReportCard from './JDReportCard';

const gridStyle = {
  width: '25%',
  textAlign: 'center',
};

const RankingResultsCard = ({ timeStamp, API_URL, author_email, run_id }) => {
  return (
    <Card title={timeStamp.pool_name}>
      {timeStamp.jds.map((jd, index) => (
        <Card.Grid style={gridStyle} key={index} hoverable={false}>
          <JDReportCard
            API_URL={API_URL}
            author_email={author_email}
            run_id={run_id}
            jd={jd}
          />
        </Card.Grid>
      ))}
    </Card>
  );
};

export default RankingResultsCard;
